export default {"src":"/_next/static/media/instagram.8cb70c0b.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};